import { InjectionToken, Provider } from '@angular/core';

import { Environment } from '@recovery/environments/env';
import { environment } from '@recovery/environments/environment';

export const ENVIRONMENT = new InjectionToken<Environment>('ENVIRONMENT');

export const environmentProvider: Provider = {
  provide: ENVIRONMENT,
  useValue: environment,
};
